import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import {FieldComponent} from '../../../types/FieldComponent';
import {compareText} from '../comparators/compareText';
import {TextFilter} from '../filters/TextFilter';
import {debounce} from 'lodash';
import TextField from '@mui/material/TextField';
import {formatPrice} from '../../../reducer/actions/formatPrice';

export const SPListField: FieldComponent<string, string[]> = ({
                                                                onChange,
                                                                defaultValue,
                                                                forcedValue,
                                                                disabled,
                                                                isMissing,
                                                              }) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue?.EUR || defaultValue?.HUF) {
        const prices = [];
        if (defaultValue?.EUR) {
          prices.push(formatPrice(defaultValue?.EUR, true));
        }
        if (defaultValue?.HUF) {
          prices.push(formatPrice(defaultValue?.HUF));
        }
        setCurrentState({
          value: prices.join('\n'),
          send: false,
        });
      } else {
        if (Array.isArray(defaultValue)) {
          setCurrentState({
            value: defaultValue.join('\n'),
            send: false,
          });
        }
      }
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);
  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  const ref = useRef<HTMLInputElement>();
  return (
    <>
      <TextField
        sx={{
          '& .MuiInputBase-input': {
            textAlign: 'right',
          },
        }}
        inputRef={ref}
        multiline
        variant="outlined"
        size={'small'}
        value={currentState.value}
        disabled={disabled}
        className={`w-full ${isMissing ? 'error' : ''}`}
        label={`${isMissing ? 'This field is missing' : ''}`}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
      />
    </>
  );
};

SPListField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

SPListField.comparator = compareText;

SPListField.FilterRenderer = TextFilter;
